import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import UIButton from 'UIComponents/button/UIButton'; // @ts-expect-error Untyped import

import ContentViewport from '../../../components/ContentViewport'; // @ts-expect-error Untyped import

import ContentControlWrapper from '../../../components/ContentControlWrapper'; // @ts-expect-error Untyped import

import ApiError from '../../../components/Errors/ApiError';
const BASE_CLASS_NAME = 'practical-exercise-error';

const PracticalExerciseError = ({
  error
}) => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx(ContentViewport, {
    paddingClassName: `${BASE_CLASS_NAME}__content`,
    children: /*#__PURE__*/_jsx(ApiError, {
      error: error
    })
  }), /*#__PURE__*/_jsx(ContentControlWrapper, {
    className: `${BASE_CLASS_NAME}__content-control`,
    children: /*#__PURE__*/_jsx(UIButton, {
      disabled: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.practicalExercise.startExercise"
      })
    })
  })]
});

export default PracticalExerciseError;